import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values  = { text: String }
  static targets = ["content"]

  connect() {
    this.tooltip = document.createElement("div")
    this.tooltip.className = "pointer-events-none fixed z-50 max-w-xs rounded bg-slate-900 px-2 py-1 text-xs leading-snug text-white shadow"
    this.tooltip.hidden = true
    document.body.appendChild(this.tooltip)

    this.boundShow = this.show.bind(this)
    this.boundHide = this.hide.bind(this)

    this.element.addEventListener("mouseenter", this.boundShow)
    this.element.addEventListener("mouseleave", this.boundHide)
    this.element.addEventListener("focusin", this.boundShow)
    this.element.addEventListener("focusout", this.boundHide)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.boundShow)
    this.element.removeEventListener("mouseleave", this.boundHide)
    this.element.removeEventListener("focusin", this.boundShow)
    this.element.removeEventListener("focusout", this.boundHide)
    this.tooltip.remove()
  }

  show(event) {
    const html = this.tooltipHTML().trim()
    if (!html) return
    this.tooltip.innerHTML = html
    this.tooltip.hidden = false
    this.tooltip.style.visibility = "hidden"
    requestAnimationFrame(() => this.positionTooltip())
  }

  hide() {
    this.tooltip.hidden = true
    this.tooltip.style.visibility = "visible"
  }

  tooltipHTML() {
    if (this.hasContentTarget) return this.contentTarget.innerHTML
    if (this.hasTextValue) return this.textValue
    return this.element.getAttribute("data-tooltip") || ""
  }

  positionTooltip() {
    if (this.tooltip.hidden) return

    const rect = this.element.getBoundingClientRect()
    const tooltipRect = this.tooltip.getBoundingClientRect()
    const offset = 8

    let left = rect.left - tooltipRect.width - offset
    let top  = rect.top - tooltipRect.height - offset

    if (left < 0) left = rect.left
    if (left + tooltipRect.width > window.innerWidth) left = Math.max(0, window.innerWidth - tooltipRect.width - offset)
    if (top < 0) top = rect.bottom + offset
    if (top + tooltipRect.height > window.innerHeight) top = Math.max(0, window.innerHeight - tooltipRect.height - offset)

    this.tooltip.style.left = `${left}px`
    this.tooltip.style.top  = `${top}px`
    this.tooltip.style.visibility = "visible"
  }
}
